export const applyTheme = (index: number) => {
  const themeName = `theme-${index}`;
  document.documentElement.setAttribute('data-theme', themeName);
  localStorage.setItem('selectedTheme', themeName);
};
